import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ClienteCarteiraConsorcioService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Cliente Carteira Consórcio por id
     * @param id ID da Cliente Carteira Consórcio
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "consorcio/cliente-carteira-consorcio/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Cliente Carteira Consórcio
     * @param id ID da Cliente Carteira Consórcio
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "consorcio/cliente-carteira-consorcio"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Cliente Carteira Consórcio
     * @param id ID da Cliente Carteira Consórcio
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "consorcio/cliente-carteira-consorcio/search"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Cliente Carteira Consórcio
     * @param id ID da Cliente Carteira Consórcio
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "consorcio/cliente-carteira-consorcio/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Cliente Carteira Consórcio
     * @param params Json Cliente Carteira Consórcio
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "consorcio/cliente-carteira-consorcio", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Cliente Carteira Consórcio
     * @param params Json Cliente Carteira Consórcio
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "consorcio/cliente-carteira-consorcio/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
